import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";
import { pricelistCaseFilesReadyBundleSchema } from "./shapes";

export const queryDuePricelistCaseFilesReadyStep = defineStepConfig({
  type: "query_due_pricelist_case_files_ready",
  name: "Query Due Pricelist Case Files Ready",
  description:
    "Find every open pricelist update case whose vendor files-ready / " +
    "upload date has arrived and whose task is assigned to a user, and " +
    "route it to that assignee. Distinct from Set-next-step follow-up chase.",
  category: "Data Access",
  libraryModule: "ItemMaster",

  inputSchema: z.object({}),

  outputSchema: z.object({
    reminders: z
      .array(pricelistCaseFilesReadyBundleSchema)
      .describe(
        "One bundle per assignee, each with the cases whose files-ready " +
          "date has arrived. Connect to Prepare Pricelist Case Files-Ready " +
          "Reminder to fan out one notification per recipient.",
      ),
    recipientCount: z.number().int().nonnegative(),
    caseCount: z.number().int().nonnegative(),
  }),

  configSchema: z.object({
    cooldownDays: z
      .number()
      .int()
      .positive()
      .default(3)
      .describe(
        "After a case is included in a files-ready reminder, suppress " +
          "further files-ready reminders for this many days.",
      ),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "60 seconds",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "5 seconds",
    },
  },
});
